import * as PracticePreference from './practice/preference';

export enum Status {
  NeverUsed = 'NEVER_USED',
  CurrentlyUse = 'CURRENTLY_USE',
  FormerlyUsed = 'FORMERLY_USED',
  NotSincePregnant = 'NOT_SINCE_PREGNANT',
  InEarlyPregnancy = 'IN_EARLY_PREGNANCY',
  InRecovery = 'IN_RECOVERY',
  PreferNotToAnswer = 'PREFER_NOT_TO_ANSWER',
  UnableToObtain = 'UNABLE_TO_OBTAIN',
  Other = 'OTHER',
}

export const statusMap: Record<Status, string> = {
  [Status.NeverUsed]: 'Never used',
  [Status.CurrentlyUse]: 'Currently use',
  [Status.FormerlyUsed]: 'Formerly used',
  [Status.NotSincePregnant]: 'Not used since pregnant',
  [Status.InEarlyPregnancy]: 'Used early in pregnancy',
  [Status.InRecovery]: 'In recovery',
  [Status.PreferNotToAnswer]: 'Prefer not to answer',
  [Status.UnableToObtain]: 'Unable to obtain',
  [Status.Other]: 'Other',
};

export enum SubstanceName {
  Amphetamines = 'AMPHETAMINES',
  Benzodiazepines = 'BENZODIAZEPINES',
  Cocaine = 'COCAINE',
  Ecstasy = 'ECSTASY',
  HallucinogensLsd = 'HALLUCINOGENS_LSD',
  Heroin = 'HEROIN',
  Inhalants = 'INHALANTS',
  InhalantsGlueSolvents = 'INHALANTS_GLUE_SOLVENTS',
  Marijuana = 'MARIJUANA',
  Methamphetamines = 'METHAMPHETAMINES',
  Opioids = 'OPIOIDS',
  PrescriptionMedications = 'PRESCRIPTION_MEDICATIONS',
  Stimulants = 'STIMULANTS',
  Synthetics = 'SYNTHETICS',
  Other = 'OTHER',
}

export const substanceNameMap: {
  [value in SubstanceName]: string;
} = {
  [SubstanceName.Amphetamines]: 'Amphetamines',
  [SubstanceName.Benzodiazepines]: 'Benzodiazepines',
  [SubstanceName.Cocaine]: 'Cocaine',
  [SubstanceName.Ecstasy]: 'Ecstasy',
  [SubstanceName.HallucinogensLsd]: 'Hallucinogens/LSD',
  [SubstanceName.Heroin]: 'Heroin',
  [SubstanceName.Inhalants]: 'Inhalants',
  [SubstanceName.InhalantsGlueSolvents]: 'Inhalants/Glues/Solvents',
  [SubstanceName.Marijuana]: 'Marijuana',
  [SubstanceName.Methamphetamines]: 'Methamphetamines',
  [SubstanceName.Opioids]: 'Opioids',
  [SubstanceName.PrescriptionMedications]: 'Prescription Medications',
  [SubstanceName.Stimulants]: 'Stimulants',
  [SubstanceName.Synthetics]: 'Synthetics',
  [SubstanceName.Other]: 'Other',
};

export interface PrevisitSubstance {
  name: SubstanceName;
  nameRaw?: string;
}

export interface PrevisitSubstanceUsage {
  status: Status;
  statusRaw?: string;
  frequency?: PracticePreference.Frequency;
  frequencyRaw?: string;
  substances?: PrevisitSubstance[];
  concernsAtHome: boolean;
}
